<template>
  <div class="document" style="height:100%">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">
            Download History
          </div>
          <div class="header-subtitle">
            Displays download history.
          </div>
        </template>
      </EsHeader>
    </div>
    <div style="padding: 1rem">
      <es-loader v-if="this.parentPage.loading === true"/>
      <div v-else>
        <table class="table is-fullwidth">
          <thead>
            <th class="has-text-grey text-align--left nowrap">
              User ID
            </th>
            <th class="has-text-grey text-align--left nowrap">
              Download Date
            </th>
          </thead>
          <tbody v-if="dmobj && historyFilter.length">
            <tr v-for="(item, index) in historyFilter" :key="index">
              <td>
                <div>
                  {{ userInfo(item) }}
                </div>
              </td>
              <td>
                {{ downloadInfo(item) | formatDateMMDDYYYYHHMM }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import { mapGetters } from 'vuex';

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
);

export default {

  components: {
    EsHeader,
    EsLoader,
  },
  mixins: [DateUtils],
  props: [
    'dmobj',
    'parentPage',
  ],
  data() {
    return {
      statusToDisplay: ['3', '4'],
    };
  },
  methods: {
    userInfo(item) {
      const email = item.userEmail || item.params.userEmail;
      return email || item.userId || item.params.userId;
    },
    downloadInfo(item) {
      return item.downloadDate || item.params.downloadDate;
    },
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    historyFilter() {
      let downloads;

      // handle old format, remove when transactions are migrated to new structure
      if (this.dmobj.fileDownloads.downloads) {
        downloads = this.dmobj.fileDownloads.downloads
          .filter(d => this.statusToDisplay.includes(d.extractStatus));
      } else {
        downloads = this.dmobj.fileDownloads
          .filter(d => this.statusToDisplay.includes(d.params.extractStatus));
      }

      return downloads.reverse().slice(0, 15);
    },
  },
};
</script>

<style lang="sass" scoped>
  .margin-bottom
    margin-bottom: 1rem
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    &:before, &:after
    border: 4px solid transparent
    display: block
    height: 0
    right: 5px
    top: 50%
    position: absolute
    width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
      &:after
        border-top-color: #999
        margin-top: 1px
  .header-container
    margin-bottom: 1rem
  .no-radius
    border-radius: 0
    background-color: #F2F2F2
    font-weight: normal
  .selected-option
    background-color: #ccc
    font-weight: bold
  .fields-container
    margin-left: 30px
  .text-align--left
    text-align: left !important
  .column-header
    padding-left: 0px
  .text-align--right
    text-align: right !important
</style>
